<template>
    <b-modal :id="modalId" title="Edit Expense" hide-footer>
        <loading-screen :is-loading="isSaving"></loading-screen>
        <errors :error-list="serverErrors"></errors>

        <form @submit.prevent="updateExpense">

            <div class="form-group mb-4">
                <label for="description">Description</label>
                <textarea v-model="updatedExpense.description" name="description" id="description" rows="2"
                    class="form-control"></textarea>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <div class="form-group mb-4">
                        <label for="amount">Currency</label>
                        <div class="btn-group">
                            <button type="button" class="btn btn-itg"
                                :class="{ 'active': updatedExpense.currency === 'GBP' }" @click="setCurrency('GBP')">
                                £
                            </button>
                            <button type="button" class="btn btn-itg"
                                :class="{ 'active': updatedExpense.currency === 'USD' }" @click="setCurrency('USD')">
                                $
                            </button>
                            <button type="button" class="btn btn-itg"
                                :class="{ 'active': updatedExpense.currency === 'JPY' }" @click="setCurrency('JPY')">
                                ¥
                            </button>
                            <button type="button" class="btn btn-itg"
                                :class="{ 'active': updatedExpense.currency === 'AUD' }" @click="setCurrency('AUD')">
                                AU$
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="form-group mb-4">
                        <label for="amount">Amount</label>
                        <input v-model="updatedExpense.amount" name="amount" id="amount" class="form-control" min="0"
                            step="0.01" type="number">
                    </div>
                </div>
            </div>

            <button type="submit" class="btn btn-itg-dark" :disabled="isSaving" @click.prevent="updateExpense">
                Update Expense
            </button>

        </form>
    </b-modal>
</template>

<script>
import axios from "axios";
import Forms from "../../../../../../mixins/Forms";
import { mapGetters } from "vuex";

export default {
    name: "EditExpenseModal",
    props: ['expense'],
    components: {},
    data() {
        return {
            isSaving: false,
            serverErrors: [],
            updatedExpense: {
                description: this.expense.description,
                currency: this.expense.currency,
                amount: Number(this.expense.amount) / 100
            }
        }
    },
    created() {
    },
    mixins: [Forms],
    computed: {
        ...mapGetters('ticketViewer', {
            ticket: 'ticket'
        }),

        modalId() {
            return 'edit-expense-' + this.expense.id + '-modal';
        }
    },
    methods: {
        setCurrency(currency) {
            this.updatedExpense.currency = currency;
        },

        updateExpense() {
            let vm = this;
            vm.serverErrors = [];
            vm.isSaving = true;

            axios.put(API_BASE + '/tickets/' + this.ticket.id + '/expenses/' + this.expense.id, {
                ...vm.updatedExpense,
                amount: Number(vm.updatedExpense.amount) * 100
            }).then(r => {
                vm.isSaving = false;
                vm.$emit('expense-updated');
                vm.$bvModal.hide(vm.modalId);
            }).catch(e => {
                console.log(e);
                vm.isSaving = false;
                vm.setErrors(e);
            });
        }
    }
}
</script>

<style scoped></style>
